export default {
  up: ["ArrowUp", "Numpad8"],
  down: ["ArrowDown", "Numpad2"],
  enter: ["NumpadEnter", "Enter"]
}
